(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/engines/base/unit-combined.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/engines/base/unit-combined.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const couponValues = svs.racing.common.constants.couponValues;
const getProductName = svs.racing.common.strings.getProductName;
const getGameTypeHelpShort = svs.racing.common.strings.getGameTypeHelpShort;
const getDrawOfGameType = svs.racing.common.util.getDrawOfGameType;
const payableStatus = svs.racing.gameEngine.payableStatus;
const engineUtils = svs.racing.gameEngine.utils.engine;
const unitCombinedUtils = svs.racing.gameEngine.utils.unitCombined;
const immutableUtils = svs.racing.gameEngine.utils.immutable;
const mathUtils = svs.racing.gameEngine.utils.math;
const UNIT_COMBINED = svs.racing.common.constants.systemTypes.UNIT_COMBINED;
const UNIT_COMBINED_UNORDERED = svs.racing.common.constants.systemTypes.UNIT_COMBINED_UNORDERED;
const gameTypes = svs.racing.common.constants.gameTypes;
const qpProps = svs.racing.common.constants.quickpickProps;
function createEngine(options) {
  const systemType = options.unordered ? UNIT_COMBINED_UNORDERED : UNIT_COMBINED;
  const getInitialState = config => {
    if (!config || !config.race || !config.race.participants) {
      throw new Error("Can't initialize engine without a config or race");
    }
    const draw = getDrawOfGameType(config.race, options.gameType);
    return {
      row: config.race.participants.map(participant => participant.canceled ? couponValues.CANCELED : undefined),
      anyOrder: false,
      reserve: undefined,
      error: undefined,
      meta: {
        raceId: config.race.raceId,
        drawNumber: draw ? draw.drawNumber : 0
      },
      qpValue: qpProps.NOQP,
      pixSize: 0
    };
  };
  const selectors = {
    getRow(state) {
      return state.row.map(value => value);
    },
    getPositions(state) {
      return unitCombinedUtils.rowToPositions(state.row, options.numPositions, value => engineUtils.isPosition(value), systemType);
    },
    getNumSelectedParticipants(state) {
      return engineUtils.countPositions(state.row);
    },
    getNumRows(state) {
      const numPositions = engineUtils.countPositions(state.row);
      if (!state.anyOrder) {
        return mathUtils.combination(numPositions, options.numPositions);
      }
      return mathUtils.partialPermutation(numPositions, options.numPositions);
    },
    isComplete(state) {
      const positions = selectors.getPositions(state);
      return positions.every(engineUtils.isPosition) && !positions.includes(undefined);
    },
    getSerializableData(state) {
      return {
        row: state.row,
        anyOrder: state.anyOrder,
        reserve: state.reserve,
        qpValue: state.qpValue,
        pixSize: state.pixSize
      };
    },
    getPayableState(state, selectedRowPrice) {
      const formatSummary = (numSelectedParticipants, numRows) => {
        const selectionsStr = "".concat(numSelectedParticipants, " h\xE4st").concat(numSelectedParticipants === 1 ? '' : 'ar');
        if (options.numPositions === 1) {
          return selectionsStr;
        }
        const formatedNumRows = svs.utils.format.Currency(numRows);
        const rowsStr = "".concat(formatedNumRows, " rad").concat(numRows === 1 ? '' : 'er');
        return [selectionsStr, rowsStr].join(' | ');
      };
      const getAmountDisabled = numRows => {
        const amountDisabled = [false, false, false];
        switch (options.gameType) {
          case gameTypes.TOPP5:
            if (numRows < 2) {
              amountDisabled[0] = true;
              amountDisabled[1] = true;
            } else if (numRows < 4) {
              amountDisabled[0] = true;
            }
            break;
          case gameTypes.RX4IO:
          case gameTypes.RX3IOAO:
          case gameTypes.RX3IO:
            if (numRows < 2) {
              amountDisabled[0] = true;
              amountDisabled[1] = false;
            }
            break;
          case gameTypes.TOPP2:
          case gameTypes.RX2P:
          case gameTypes.RX2P4:
          case gameTypes.RX2IO:
          case gameTypes.RX3AO:
            if (numRows < 2) {
              amountDisabled[0] = true;
            }
            break;
          default:
            break;
        }
        return amountDisabled;
      };
      const numSelectedParticipants = selectors.getNumSelectedParticipants(state);

      if (numSelectedParticipants < options.numPositions) {
        const formatIncompleteStatus = numSelected => {
          let statusStr = '';
          if (numSelected === 0) {
            statusStr = getGameTypeHelpShort(options.gameType);
          } else {
            statusStr = "".concat(numSelected, " av ").concat(options.numPositions, " h\xE4star valda");
          }
          return statusStr;
        };
        return {
          status: payableStatus.INCOMPLETE,
          summaryText: formatSummary(numSelectedParticipants, 0),
          statusText: formatIncompleteStatus(numSelectedParticipants),
          amount: 0,
          amountDisabled: getAmountDisabled(0)
        };
      }

      const isComplete = selectors.isComplete(state);
      if (!isComplete) {
        const formatMissingStatus = missingPositions => {
          if (missingPositions.length < 4) {
            if (missingPositions.length === 1) {
              return "V\xE4lj en h\xE4st p\xE5 plats ".concat(missingPositions[0]);
            }
            return "V\xE4lj h\xE4star p\xE5 plats ".concat(missingPositions.slice(0, -1).join(', '), " och ").concat(missingPositions[missingPositions.length - 1]);
          }
          return "V\xE4lj h\xE4star p\xE5 alla platser";
        };
        const allPositions = unitCombinedUtils.rowToPositions(state.row, 0, engineUtils.isPosition, systemType);
        const missingPositions = allPositions.reduce((acc, value, index) => {
          if (value === undefined) {
            acc.push(engineUtils.indexToPosition(index));
          }
          return acc;
        }, []);
        return {
          status: payableStatus.INCOMPLETE,
          summaryText: formatSummary(numSelectedParticipants, 0),
          statusText: formatMissingStatus(missingPositions),
          amount: 0,
          amountDisabled: getAmountDisabled(0)
        };
      }

      const numRows = selectors.getNumRows(state);
      const totalPrice = selectedRowPrice * numRows;

      if (totalPrice > options.stake.max) {
        return {
          status: payableStatus.MAX_AMOUNT,
          summaryText: formatSummary(numSelectedParticipants, numRows),
          statusText: "Maxinsatsen \xE4r ".concat(svs.utils.format.Currency(options.stake.max), " kr"),
          amount: totalPrice,
          amountDisabled: getAmountDisabled(numRows)
        };
      }

      if (totalPrice < options.stake.min) {
        return {
          status: payableStatus.MIN_AMOUNT,
          summaryText: formatSummary(numSelectedParticipants, numRows),
          statusText: "Minsta insatsen \xE4r ".concat(svs.utils.format.Currency(options.stake.min), " kr"),
          amount: totalPrice,
          amountDisabled: getAmountDisabled(numRows)
        };
      }

      if (options.stake.freeAmountAvailable) {
        let invalidRowPriceText;
        const minInputRowPrice = options.stake.minInputRowPrice;
        switch (options.gameType) {
          case gameTypes.TOPP2:
          case gameTypes.RX2P:
          case gameTypes.RX3AO:
          case gameTypes.RX3IOAO:
          case gameTypes.RX3IO:
          case gameTypes.RX2IO:
          case gameTypes.RX2P4:
            if (selectedRowPrice < options.stake.minInputRowPrice && options.stake.amounts.indexOf(selectedRowPrice) < 0) {
              invalidRowPriceText = "Minsta valfria insats per rad \xE4r ".concat(svs.utils.format.Currency(minInputRowPrice), " kr");
            }
            break;
          case gameTypes.VINNARE:
          case gameTypes.PLATS:
            if (selectedRowPrice < minInputRowPrice) {
              invalidRowPriceText = "Minsta insats per h\xE4st \xE4r ".concat(svs.utils.format.Currency(minInputRowPrice), " kr");
            }
            break;
          default:
            break;
        }
        if (invalidRowPriceText) {
          return {
            status: payableStatus.INVALID_ROW_PRICE,
            summaryText: formatSummary(numSelectedParticipants, numRows),
            statusText: invalidRowPriceText,
            amount: totalPrice,
            amountDisabled: getAmountDisabled(numRows)
          };
        }
      }

      return {
        status: payableStatus.VALID,
        summaryText: formatSummary(numSelectedParticipants, numRows),
        statusText: "".concat(getProductName(options.gameType).toUpperCase(), " \u2013 Redo att betalas!"),
        amount: totalPrice,
        amountDisabled: getAmountDisabled(numRows)
      };
    },
    getWagerData(state, participants) {
      const positions = selectors.getPositions(state);
      const reserve = selectors.getReserve(state);
      const hasReserve = selectors.hasReserve(state);
      const qpValue = selectors.getQP(state);
      let rxBoards = [];
      let updatedReserveIndex;
      let automaticReserve;
      let updatedReserve;
      let reservesAvailable = true;

      if (hasReserve && reserve === undefined) {
        const possibleReserves = selectors.getPossibleReserves(state, participants, positions);
        if (possibleReserves.length > 0) {
          automaticReserve = unitCombinedUtils.getAutomaticReserve(possibleReserves);
          updatedReserveIndex = participants.findIndex(participant => participant.participantId === automaticReserve.participantId) + 1;
        } else {
          reservesAvailable = false;
        }
      }
      if (reservesAvailable) {
        updatedReserve = updatedReserveIndex ? updatedReserveIndex : reserve + 1;
      }
      const boardProps = hasReserve && reservesAvailable ? ['REPLACEMENT'] : [];
      if (qpValue !== qpProps.NOQP) {
        boardProps.push(qpValue);
      }
      if (systemType === UNIT_COMBINED_UNORDERED) {
        rxBoards = [{
          boardProps,
          systemType: ['RX_NOPOS'],
          systemNum: 1,
          rxRaces: [[], positions],
          extras: [],
          replacement: hasReserve && reservesAvailable ? updatedReserve : undefined
        }];
      } else if (state.anyOrder) {
        rxBoards = [{
          boardProps,
          systemType: ['RX_NOPOS'],
          systemNum: 1,
          rxRaces: [[], positions],
          extras: [],
          replacement: hasReserve && reservesAvailable ? updatedReserve : undefined
        }];
      } else {
        rxBoards = [{
          boardProps,
          systemType: ['RX_POS'],
          systemNum: 1,
          rxRaces: new Array(options.numPositions).fill([]),
          extras: positions,
          replacement: hasReserve && reservesAvailable ? updatedReserve : undefined
        }];
      }
      return rxBoards;
    },
    getMeta(state) {
      return state.meta;
    },
    hasAnySet(state) {
      return state.row.some(engineUtils.isPosition);
    },
    hasError(state) {
      return Boolean(state.error);
    },
    isAnyOrder(state) {
      return state.anyOrder;
    },
    getReserve(state) {
      return state.reserve;
    },
    hasReserve(state) {
      return state.reserve !== -1 && options.hasReserve;
    },
    getPossibleReserves(state, participants, selectedPositions) {
      return participants.filter((value, index) => selectedPositions.indexOf(index + 1) === -1 && value.canceled === false);
    },
    getValidReservePositions(state) {
      return state.row.map(value => {
        if (engineUtils.isPosition(value) || !engineUtils.isAvailable(value)) {
          return false;
        }
        return true;
      });
    },
    getQP(state) {
      return state.qpValue;
    },
    getPixSize(state) {
      return state.pixSize;
    }
  };
  const actions = {
    initialize(race) {
      return {
        type: 'INITIALIZE',
        race
      };
    },
    trySetData: data => ({
      type: 'TRY_SET_DATA',
      data
    }),
    toggleIndex(index) {
      return {
        type: 'TOGGLE_INDEX',
        index
      };
    },
    setReserve(index) {
      return {
        type: 'SET_RESERVE',
        index
      };
    },
    setAnyOrder(state) {
      return {
        type: 'SET_ANY_ORDER',
        state
      };
    },
    clearAll() {
      return {
        type: 'CLEAR_ALL'
      };
    },
    clearError() {
      return {
        type: 'CLEAR_ERROR'
      };
    }
  };
  const reducer = (state, action) => {
    switch (action.type) {
      case 'INITIALIZE':
        {
          return getInitialState({
            race: action.race
          });
        }
      case 'TRY_SET_DATA':
        {
          const reserveValidationFn = (index, value) => !engineUtils.isPosition(value);
          const qpValue = action.data.qpValue ? action.data.qpValue : qpProps.NOQP;
          const parsed = engineUtils.parseData(state.row, action.data, true, undefined, reserveValidationFn);
          return _objectSpread(_objectSpread({}, state), {}, {
            row: parsed.row,
            error: parsed.error,
            anyOrder: Boolean(action.data.anyOrder),
            reserve: parsed.reserve,
            qpValue,
            pixSize: action.data.pixSize || 0
          });
        }
      case 'TOGGLE_INDEX':
        {
          if (action.index > state.row.length - 1 || action.index < 0) {
            return state;
          }
          const currentValue = state.row[action.index];
          if (currentValue === couponValues.CANCELED) {
            return state;
          }
          const qpValue = state.qpValue === qpProps.WEIGHTEDQP || state.qpValue === qpProps.MODIFIEDQP ? qpProps.MODIFIEDQP : qpProps.NOQP;
          let currentReserve = state.reserve;
          if (action.index === currentReserve) {
            currentReserve = undefined;
          }
          const newValue = engineUtils.isPosition(currentValue) ? undefined : unitCombinedUtils.getNextPosition(state.row);
          const row = immutableUtils.updateArrayIndex(state.row, action.index, () => newValue);
          return _objectSpread(_objectSpread({}, state), {}, {
            row,
            reserve: currentReserve,
            qpValue
          });
        }
      case 'SET_RESERVE':
        {
          if (action.index === state.reserve) {
            return state;
          }
          if (action.index < -1 || action.index > state.row.length - 1) {
            return state;
          }
          if (!engineUtils.isAvailable(state.row[action.index])) {
            return state;
          }
          return _objectSpread(_objectSpread({}, state), {}, {
            reserve: action.index,
            error: true
          });
        }
      case 'SET_ANY_ORDER':
        {
          if (action.state === state.anyOrder) {
            return state;
          }
          return _objectSpread(_objectSpread({}, state), {}, {
            anyOrder: Boolean(action.state)
          });
        }
      case 'CLEAR_ALL':
        return _objectSpread(_objectSpread({}, state), {}, {
          row: immutableUtils.updateArray(state.row, value => value === couponValues.CANCELED ? couponValues.CANCELED : undefined),
          reserve: undefined,
          qpValue: qpProps.NOQP,
          pixSize: 0
        });
      case 'CLEAR_ERROR':
        return _objectSpread(_objectSpread({}, state), {}, {
          error: undefined
        });
      default:
        return state;
    }
  };
  return _objectSpread(_objectSpread({}, options), {}, {
    systemType,
    getInitialState,
    selectors,
    actions,
    reducer
  });
}
svs.racing.gameEngine.engines.createEngineUnitCombined = createEngine;

 })(window);